'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');
const moment = require('moment');

import routes from './home.routes';

export class HomeComponent {

  constructor($state, dialogs, $uibModal, Auth, VotingsService, IntegrationService, SettingsService, User, ContactService,
              PropertyService, VoterGroupsService) {
    'ngInject';

    this.$state = $state;
    this.dialogs = dialogs;
    this.$uibModal = $uibModal;
    this.Auth = Auth;
    this.User = User;
    this.VotingsService = VotingsService;
    this.VoterGroupsService = VoterGroupsService;
    this.ContactService = ContactService;
    this.PropertyService = PropertyService;
    this.IntegrationService = IntegrationService;

    this.Auth.isAdmin(isAdmin => {
      this.isAdmin = isAdmin;

      this.Auth.getCurrentUser(user => {
        this.userId = user._id;

        SettingsService.getByName({name: 'client'}, settings => {
          this.optInOutRequired = settings.data.optInOut && settings.data.optInOut.required;
          this.hideOptInOut = !settings.data.optInOut || (settings.data.optInOut && settings.data.optInOut.hidden);
          if (this.optInOutRequired) {
            this.optInOutSettings = settings.data.optInOut;
          }

          this.useSuite = settings.data.useSuite;
          this.hideProxy = !settings.data.proxy || (settings.data.proxy && settings.data.proxy.hidden);

          this.hiddenBallots = settings.data.hiddenBallots || [];

          this.reloadData();
        });


      });
    });
  }

  isHidden(id) {
    return this.hiddenBallots.includes(id);
  }

  reloadData() {
    let onSuccess = result => {
      this.eVotingConsent = result.consent;
      this.eVotingFirstTime = !!result.eform;

      let PROPERTIES_METHOD = (this.useSuite)
        ? this.User.querySuitePropertiesByUser
        : this.PropertyService.getPropertiesVotingByUser;

      PROPERTIES_METHOD({contactId: this.userId}, data => {

        if (data && data[0]) {
          this.properties = data.filter(d => d.json)
            .map(d => JSON.parse(d.json))
            .map(d => d.property)
            .filter(d => d.eVoting && !d.eVoting.blocked);
        } else {
          this.properties = [];

          if (this.isAdmin) {
            this.properties = [{
              "_id": "0001",
              "lotNo": "100",
              "address": {
                "street": "100 Test Street"
              }
            }, {
              "_id": "0002",
              "lotNo": "200",
              "address": {
                "street": "200 Test Street"
              }
            }];
          }
        }

        this.ownPropertyIds = this.properties.map(ppty => ppty._id);

        this.VotingsService.query(data => {
          let votings = data
            .filter(voting => voting.voterGroup && typeof voting.voterGroup === 'object')
            .map(voting => { voting.description = this.convertShortcode(voting.description); return voting; });

          this.upcoming = votings
            .filter(v => v.state == 'open' || (v.state == 'draft' && this.isAdmin))
            .filter(v => v.voterGroup && ( v.voterGroup.properties.some(id => this.ownPropertyIds.includes(id)) || v.voterGroup.contacts.includes(this.userId) || this.isAdmin ))
            .filter(vote => moment(vote.period.till).isAfter(moment()));

          this.past = votings
            .filter(v => v.voterGroup && ( v.voterGroup.properties.some(id => this.ownPropertyIds.includes(id)) || v.voterGroup.contacts.includes(this.userId) || this.isAdmin ))
            .filter(vote => vote.state == 'closed' || moment(vote.period.till).isBefore(moment()));
        });

      }, err => {
        console.log("Could not retrieve users.")
      });

    };

    if (this.isAdmin) { // preview mode
      onSuccess({consent: true, eVotingFirstTime: true});
    } else {
      let CONSENT_METHOD = (this.useSuite)
        ? this.IntegrationService.suiteGetEVotingConsent
        : this.ContactService.getEVotingConsent;

      CONSENT_METHOD({contactId: this.userId}, onSuccess, err => {
        //toddo: log error
      });
    }

  }

  isAtLeastOneEVoteRecorded(voting) {
    let votes = voting.votes.filter(v => v.type == 'evote' && (v.voter == this.userId || this.ownPropertyIds.includes(v.property) ));
    return votes.length > 0;
  }

  isAtLeastOneBallotDone(voting) {
    let oneDone = false;

    voting.ballots.forEach(ballot => {
      let alreadyVotedCount = voting.votes.filter(v => v.ballot == ballot._id && (v.voter == this.userId || this.ownPropertyIds.includes(v.property))).length;

      let votingProperties = this.getVotingProperties(voting);

      if (votingProperties.length - alreadyVotedCount <= 0) // <= ??
        oneDone = true;
    });

    return oneDone;
  }

  getOpenVotes(voting, ballot) {
    let alreadyVotedCount = voting.votes.filter(v => v.ballot == ballot._id && (v.voter == this.userId || this.ownPropertyIds.includes(v.property))).length;
    let proxyCount = voting.proxies.filter(p => this.ownPropertyIds.includes(p.property) && p.proxy.enabled).length;

    let votingProperties = this.getVotingProperties(voting);

    return votingProperties.length - alreadyVotedCount - proxyCount;
  }

  getOpenContactVotes(voting, ballot) {
    return 1 - voting.votes.filter(v => v.voter == this.userId && v.ballot == ballot._id).length;
  }

  getVotingProperties(voting) {
    if (this.isAdmin)
      return this.properties;

    // filter by voter group properties only
    return this.properties.filter(d => voting.voterGroup.properties.includes(d._id));
  }

  openOptInModal(vote) {
    var that = this;

    if (moment(vote.optInDeadline).isBefore(moment(),'days')) {
      alert('The deadline for opting in to E-Voting has already been expired');
      return;
    }

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'eFormModal',
      resolve: {
        config: function(){
          return {
            eFormId: that.optInOutSettings.optInForm
          }
        }
      }
    });

    modalInstance.result.then(
      function (eFormResponseId) {

        let UPDATE_METHOD = (that.useSuite)
          ? that.IntegrationService.suiteUpdateEVotingConsent
          : that.ContactService.updateEVotingConsent;

        UPDATE_METHOD({contactId: that.userId}, {
          consent: true,
          eform: eFormResponseId
        },_=>{
          that.reloadData();
        }, err => console.log(err));
      },
      function () { /* cancel */ }
    );
  }

  openOptOutModal(vote) {
    var that = this;

    if (moment(vote.optOutDeadline).isBefore(moment(),'days')) {
      alert('The deadline for opting out of E-Voting has already been expired');
      return;
    }

    if (this.isAdmin) {
      alert('You cannot Opt-Out in Preview Mode!');
      return;
    }

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'eFormModal',
      resolve: {
        config: function(){
          return {
            eFormId: that.optInOutSettings.optOutForm
          }
        }
      }
    });

    modalInstance.result.then(
      function (eFormResponseId) {
        let UPDATE_METHOD = (that.useSuite)
          ? that.IntegrationService.suiteUpdateEVotingConsent
          : that.ContactService.updateEVotingConsent;

        UPDATE_METHOD({contactId: that.userId}, {
          consent: false,
          eform: eFormResponseId
        },_=>{
          that.reloadData();
        }, err => console.log(err));
      },
      function () { /* cancel */ }
    );
  }

  convertShortcode(html) {
    if (html)
      return html.replace(/\[/g,"<").replace(/\]/g,">");
    else
      return "";
  }

  openProxyModal(voteId) {
    var that = this;

    this.VotingsService.get({id: voteId}, vote => {
      let proxies = vote.proxies.filter(v => this.ownPropertyIds.includes(v.property));
      let myVotes = vote.votes.filter(v => this.ownPropertyIds.includes(v.property));

      var modalInstance = this.$uibModal.open({
        animation: true,
        component: 'specifyProxy',
        size: 'md',
        resolve: {
          config: function() {
            return {
              defaultProxy: vote.defaultProxy,
              proxies: proxies,
              properties: that.properties.filter(ppty => !myVotes.find(vote => vote.property == ppty._id))
            }
          }
        }
      });

      modalInstance.result.then(
        function (ret) {

          if (that.isAdmin) {
            alert('You cannot Set or Remove a Proxy in Preview Mode!');
            return;
          }

          that.VotingsService.updateProxy({id: voteId, propertyId: ret.propertyId}, ret.proxy, _=>{
            that.reloadData();
          }, err => {
            console.log(err);
          })
        },
        function () { /* cancel */ }
      );

    });

  }

}

export default angular.module('conduu.home', [uiRouter])
  .config(routes)
  .component('home', {
    template: require('./home.html'),
    controller: HomeComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/home/home.component.js